import { Box, Typography } from "@mui/material";
import { HidroLayerGroup, HidroMap, PaintDefault } from "../../mapa";

export interface PropsMapLayerStyle {
  file: string;
  layer?: string;
  style: PaintDefault;
}
export interface PropsMap {
  title: string;
  position?: "center" | "start" | "end";
  width: number;
  height: number;
  layers: HidroLayerGroup;
}

export const MapItemOnText: React.FC<PropsMap> = (data) => {
  const { title, position, width, height, layers } = data;

  return <Box sx={{
    width: "100%",
    display: "flex",
    flexDirection: "column",
    padding: "0px",
    alignItems: "center",
  }}>
    <Typography fontWeight={"bold"} fontSize={18}>
      {title != "" ? (title ?? "Preview") : "Preview"}
    </Typography>

    <Box sx={{
      width: "100%",
      display: "flex",
      flexDirection: "column",
      padding: "15px",
      alignItems: position ?? "center",
    }}>
      <Box
        sx={{
          height: `${height}px`,
          width: `${width ?? 100}px`,
          border: "1px solid black"
        }}
      >
        <HidroMap
          startWithTile
          animateStart
          expandable
          limitBounds
          showTooltips
          recenter
          hidroLayers={layers}
        />
      </Box>
    </Box>
  </Box>;
};